<route>
{
    "name": "dashboard",
    "meta": {
        "title": "Dashboard",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate", "birou", "service"],
        "fail": "/403"
    }
}
</route>
<template>
  <main-layout>

      <v-container v-if="getMe">
          <v-row>
              <v-col md="6" sm="12">
                  <h1 class="pt-3">Salut {{ getMe.name }}!</h1>
              </v-col>
              <v-col v-if="hasRole('admin')" md="6" sm="12">
                  <user-selector button-class="mt-3" v-model="filterByUser"></user-selector>
              </v-col>
          </v-row>
      </v-container>
      <v-container v-if="canSeeOffers" fluid grid-list-xl class="mx-4">
          <v-layout>
              <v-row :style="{minHeight: '70vh', overflowX: 'scroll', flexWrap: 'nowrap'}">
                  <v-col v-for="(status, index) in offerStatuses" :key="index" cols="3">
                      <v-card :loading="loading" color="#F8F8F8" :style="{height: '100%'}">
                          <template slot="progress">
                              <v-overlay absolute class="d-flex flex-column text-center">
                                  <div>
                                      <v-progress-circular size="250" width="10" color="primary" indeterminate>
                                          <span>In curs de incarcare...</span>
                                      </v-progress-circular>
                                  </div>
                              </v-overlay>
                          </template>
                          <v-card-title>{{ status.text }}</v-card-title>
                          <v-card-text class="px-1">
                              <template v-if="status.orders.length > 0">
                                  <v-card v-for="(offer, oIndex) in status.orders" :key="oIndex" class="my-2">
                                      <v-card-text class="pb-0">
                                          <h3 class="h6 d-inline-block">{{ offer.document_number }}</h3>
                                          <h3 class="h6 d-inline-block pull-right">{{ new Date(offer.created_at) | date }}</h3>
                                          <p>
                                              Valoare: {{ offer.amount_with_vat | price }}
                                          </p>
                                      </v-card-text>
                                      <v-card-subtitle class="pt-0">
                                          <p>{{ offer.customer.name }}</p>
                                      </v-card-subtitle>
                                      <v-card-actions>
                                          <v-btn
                                              v-if="['NEW'].indexOf(offer.status) >= 0"
                                              color="orange lighten-1"
                                              text
                                              @click="setStatus(offer, 'ACTIVE')"
                                          >
                                              Preluare
                                          </v-btn>

                                          <v-spacer></v-spacer>
                                          <v-btn
                                              color="primary lighten-1"
                                              text
                                              :href="$router.resolve({name: 'offers-edit', params: {id: offer.id}}).href"
                                              @click="$router.push({name: 'offers-edit', params: {id: offer.id}})"
                                          >
                                              Vizualizare
                                          </v-btn>
                                      </v-card-actions>
                                  </v-card>
                              </template>
                              <div v-else-if="!loading" class="mx-5 my-5 text-center">
                                  <h3 class="h5">Good job!</h3>
                                  <svg class="good-job-svg" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><g><path d="m301.124 42.05 36.786-37.796c7.647-7.857 20.946-4.293 23.64 6.334l12.959 51.125c1.425 5.621 7.206 8.959 12.787 7.382l50.755-14.339c10.551-2.981 20.287 6.755 17.306 17.306l-14.339 50.755c-1.577 5.58 1.761 11.362 7.382 12.787l51.125 12.959c10.627 2.694 14.191 15.994 6.334 23.64l-37.796 36.786c-4.156 4.044-4.156 10.72 0 14.765l37.796 36.786c7.857 7.647 4.293 20.946-6.334 23.64l-51.125 12.96c-5.621 1.425-8.959 7.206-7.382 12.787l14.339 50.755c2.981 10.551-6.755 20.287-17.306 17.306l-60.941-17.217-15.56 61.385c-2.694 10.627-15.994 14.191-23.64 6.334l-44.168-45.381-44.168 45.381c-7.647 7.857-20.946 4.293-23.64-6.334l-15.56-61.385-60.941 17.217c-10.551 2.981-20.287-6.755-17.306-17.306l17.217-60.941-61.385-15.56c-10.627-2.694-14.191-15.994-6.334-23.64l37.796-36.786c4.156-4.044 4.156-10.72 0-14.765l-37.796-36.786c-7.857-7.647-4.293-20.946 6.334-23.64l51.125-12.959c5.621-1.425 8.959-7.206 7.382-12.787l-14.339-50.755c-2.981-10.551 6.755-20.287 17.306-17.306l50.755 14.339c5.58 1.577 11.362-1.761 12.787-7.382l12.959-51.125c2.694-10.627 15.994-14.191 23.64-6.334l36.786 37.796c4.044 4.154 10.719 4.154 14.764-.001z" fill="#fcb44d"/><path d="m505.858 260.54c7.852 7.642 4.291 20.949-6.338 23.641l-51.117 12.963c-5.62 1.425-8.957 7.205-7.382 12.785l14.33 50.755c2.987 10.544-6.745 20.29-17.303 17.303l-60.939-17.219-15.564 61.388c-2.692 10.629-15.985 14.19-23.641 6.338l-9.114-9.367 21.552-94.69c.897-3.912 4.88-6.282 8.736-5.188l40.257 11.372c5.286 1.5 10.152-3.379 8.665-8.652l-11.428-40.425c-1.08-3.8 1.192-7.74 5.02-8.708l40.733-10.32c5.314-1.346 7.095-7.992 3.169-11.82l-30.119-29.306c-2.818-2.748-2.818-7.291 0-10.04l30.119-29.306c3.926-3.828 2.145-10.474-3.169-11.82l-40.733-10.32c-3.814-.968-6.099-4.908-5.02-8.708l11.428-40.425c1.486-5.272-3.379-10.138-8.665-8.651l-40.411 11.414c-3.8 1.08-7.74-1.206-8.708-5.034l-23.389-92.88 11.077-11.372c7.656-7.852 20.949-4.291 23.641 6.338l12.963 51.128c1.425 5.621 7.207 8.959 12.787 7.382l50.753-14.341c10.558-2.973 20.29 6.758 17.303 17.303l-14.33 50.755c-1.575 5.58 1.762 11.36 7.382 12.785l51.117 12.963c10.629 2.692 14.19 15.999 6.338 23.641l-37.791 36.787c-4.155 4.044-4.155 10.719 0 14.764z" fill="#fb9927"/></g><g><g><g><g><g><path d="m384.764 311.469h-3.407c19.167 0 34.748-15.355 35.113-34.435.377-19.689-16.115-35.805-35.807-35.805h-101.817c-3.703 0-6.197-3.791-4.73-7.191l14.972-34.703c.832-1.929 1.477-3.933 1.927-5.986l3.612-16.495c7.055-32.217-17.478-62.704-50.458-62.704-10.132 0-19.018 6.766-21.713 16.533l-13.457 48.772-49.985 89.415c-1.821 3.257-5.261 5.275-8.992 5.275h-73.259v191.962h119.511l9.675 8.705c9.432 8.513 21.645 13.197 34.35 13.197h126.413c15.628 0 28.839-12.253 29.268-27.876.444-16.209-12.562-29.488-28.671-29.488h10.696c15.752 0 28.522-12.77 28.522-28.522 0-15.752-12.77-28.522-28.522-28.522h7.405c17.448 0 31.536-14.383 31.055-31.94-.464-16.92-14.773-30.192-31.701-30.192z" fill="#fda79b"/><path d="m416.482 342.532c0 17.164-13.918 31.07-31.07 31.07h-7.413c7.885 0 15.008 3.186 20.168 8.358 5.16 5.16 8.358 12.295 8.358 20.168 0 15.747-12.767 28.514-28.526 28.514h-10.696c15.844 0 28.683 12.852 28.683 28.683 0 15.844-12.84 28.683-28.683 28.683h-36.048c15.844 0 28.683-12.84 28.683-28.683 0-15.832-12.84-28.683-28.683-28.683h10.696c15.759 0 28.526-12.767 28.526-28.514 0-7.873-3.198-15.008-8.358-20.168-5.16-5.172-12.282-8.358-20.168-8.358h7.413c17.152 0 31.058-13.906 31.058-31.07 0-17.152-13.906-31.058-31.058-31.058h-4.058c19.393 0 35.116-15.723 35.116-35.128 0-19.393-15.723-35.115-35.116-35.115h36.048c19.393 0 35.128 15.723 35.128 35.115 0 19.405-15.735 35.128-35.128 35.128h4.058c17.152 0 31.07 13.906 31.07 31.058z" fill="#fc9085"/><path d="m294.626 176.85-3.61 16.498c-.448 2.059-1.09 4.058-1.926 5.984l-18.073 41.899h-36.047l18.073-41.899c.824-1.926 1.478-3.925 1.926-5.984l3.61-16.498c5.354-24.456-7.498-47.907-28.429-57.791.121-.109.242-.206.375-.303 3.828-2.907 8.576-4.603 13.639-4.603 32.983.001 57.524 30.489 50.462 62.697z" fill="#fc9085"/><g><path d="m278.849 241.227h-43.875c-4.275 0-7.726-3.451-7.726-7.726 0-4.265 3.451-7.726 7.726-7.726h42.711l-3.564 8.262c-1.473 3.399 1.02 7.19 4.728 7.19z" fill="#fc9085"/></g><g><path d="m405.644 319.191h-58.349c-4.275 0-7.726-3.451-7.726-7.726 0-4.265 3.451-7.726 7.726-7.726h56.042c-6.016 4.842-13.671 7.726-21.984 7.726h3.41c7.911 0 15.256 2.905 20.881 7.726z" fill="#fc9085"/></g><g><path d="m378.004 373.605c7.551 0 14.412 2.936 19.512 7.726h-56.66c-4.275 0-7.726-3.461-7.726-7.726s3.451-7.726 7.726-7.726h65.046c-5.46 4.811-12.64 7.726-20.49 7.726z" fill="#fc9085"/></g><g><path d="m367.311 430.647c7.562 0 14.453 2.936 19.573 7.726h-58.906c-4.275 0-7.726-3.461-7.726-7.726s3.451-7.726 7.726-7.726h69.537c-5.099 4.79-11.96 7.726-19.512 7.726z" fill="#fc9085"/></g></g></g><g><path d="m12.191 253.1h79.874c6.306 0 11.417 5.112 11.417 11.417v212.073c0 6.306-5.112 11.417-11.417 11.417h-79.874c-5.69 0-10.302-4.612-10.302-10.302v-214.303c0-5.689 4.612-10.302 10.302-10.302z" fill="#64b9fc"/><path d="m103.486 264.514v212.076c0 6.307-5.119 11.416-11.416 11.416h-36.581c6.307 0 11.416-5.109 11.416-11.416v-212.076c0-6.297-5.109-11.416-11.416-11.416h36.581c6.296 0 11.416 5.119 11.416 11.416z" fill="#31a7fb"/></g></g><g><path d="m45.778 464.37h-12.19c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h12.191c4.267 0 7.726 3.459 7.726 7.726s-3.46 7.726-7.727 7.726z" fill="#c4e1ff"/></g></g><g><g><circle cx="154.295" cy="441.753" fill="#83d167" r="70.247"/><path d="m224.537 441.749c0 38.799-31.441 70.25-70.24 70.25-9.923 0-19.373-2.06-27.93-5.771.83.032 1.671.053 2.512.053 35.635 0 64.522-28.897 64.522-64.532s-28.886-64.522-64.522-64.522c-.841 0-1.682.021-2.512.053 8.556-3.711 18.007-5.771 27.93-5.771 38.799 0 70.24 31.452 70.24 70.24z" fill="#54c032"/></g><g><g><g><path d="m155.809 476.35c-3.63 0-7.26-1.384-10.029-4.154l-26.977-26.977c-5.539-5.538-5.539-14.518 0-20.057 5.538-5.539 14.52-5.539 20.057 0l14.763 14.763c1.207 1.207 3.164 1.207 4.371 0l56.845-56.845c5.54-5.538 14.52-5.537 20.057 0 5.539 5.539 5.539 14.519 0 20.057l-69.059 69.059c-2.768 2.769-6.398 4.154-10.028 4.154z" fill="#f8f3f1"/></g></g></g></g></g></g></svg>
                              </div>
                          </v-card-text>
                      </v-card>
                  </v-col>
              </v-row>
          </v-layout>
      </v-container>
  </main-layout>
</template>

<script>
import MainLayout from "Layouts/Main.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import ACL from "Mixins/acl";

export default {
    mixins: [ACL],
    components: {
        MainLayout
    },
    data () {
        return {
            offers: [],
            filterByUser: [],
            loading: true,
            period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
        }
    },
    computed: {
        ...mapGetters({
            getMe: "getMe"
        }),
        canSeeOffers () {
            return this.$canAccessRoute('offers-index')
        },
        offerStatuses() {
            return (new this.$db.Offer).statuses.map((status) => {
                status.orders = this.offers.filter(o => o.status === status.id)
                return status
            })
        }
    },
    watch: {
        filterByUser: {
            async handler(val) {
                await this.initialize()
            }
        }
    },
    async mounted () {
        this.initialize()
    },
    methods: {
        async initialize() {
            if (!this.canSeeOffers) return
            this.loading = true
            var query = this.$db.Offer
                .append('document_number')
                .include('customer')
                .limit(100);
            if(this.period instanceof Array && this.period.length === 2) {
                query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
            }
            if(!this._.isNil(this.filterByUser)) query = query.where('created_by', this.filterByUser.join(','))
            if(!this.hasRole('admin')) {
                query = query.where('created_by', this.getMe.id)
            }
            this.offers = await query.get().then(({data}) => data)
            this.loading = false
        },
        async setStatus(offer, status) {
            this.loading = true
            await axios.post(route('offers.set-status', {
                workstation: offer.workstation_id,
                offerId: offer.id,
                status: status
            })).then(async () => {
                await this.initialize()
            }).finally(() => {
                this.loading = false
            })
        },
    }
};
</script>
<style lang="scss">
.good-job-svg {
    width: 50%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    display: block;
}
</style>
